import { render } from "./CustomerEdit.vue?vue&type=template&id=ba7927ac&scoped=true"
import script from "./CustomerEdit.vue?vue&type=script&lang=js"
export * from "./CustomerEdit.vue?vue&type=script&lang=js"

import "./CustomerEdit.vue?vue&type=style&index=0&id=ba7927ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7927ac"]])

export default __exports__